export default "__VITE_ASSET__2JYDGWg2__"